import { useTranslation, Trans } from 'next-i18next';

const BeddingSection = () => {
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tHomeCommon } = useTranslation('', { keyPrefix: '$pages.$home.$common' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedding' });

  return (
    <section className="bedding-section">
      <a href={tLinks('throws')} className="upsell-items-link">
        <picture>
          <source srcSet="/images/misc/fill.gif" media="(max-width: 660px)" />
          <img
            src="/images/homePage/beddingSection/edition-throws.jpg"
            alt={tCategory('throws')}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width="800"
            height="455"
          />
        </picture>
        <h3 className="tlt-related" aria-hidden="true">
          <Trans
            i18nKey="categoryName"
            t={tHomeCommon}
            values={{ categoryName: tCategory('throws') }}
            components={{ span: <span /> }}
          />
        </h3>
      </a>
      <a href={tLinks('limitedEdition')} className="upsell-items-link">
        <picture>
          <source srcSet="/images/misc/fill.gif" media="(max-width: 660px)" />
          <img
            src="/images/homePage/beddingSection/limited-edition.jpg"
            alt={tCategory('limitedEdition')}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width="800"
            height="455"
          />
        </picture>
        <h3 className="tlt-related" aria-hidden="true">
          <Trans
            i18nKey="categoryName"
            t={tHomeCommon}
            values={{ categoryName: tCategory('limitedEdition') }}
            components={{ span: <span /> }}
          />
        </h3>
      </a>
      <a href={tLinks('artistSeries')} className="upsell-items-link">
        <picture>
          <source srcSet="/images/misc/fill.gif" media="(max-width: 660px)" />
          <img
            src="/images/homePage/beddingSection/artist-series.jpg"
            alt={tCategory('artistSeries')}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width="800"
            height="455"
          />
        </picture>
        <h3 className="tlt-related" aria-hidden="true">
          <Trans
            i18nKey="categoryName"
            t={tHomeCommon}
            values={{ categoryName: tCategory('artistSeries') }}
            components={{ span: <span /> }}
          />
        </h3>
      </a>
    </section>
  );
};

export default BeddingSection;
